import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-415">
      <div className="max-w-5xl mx-auto" data-id="element-416">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-12" data-id="element-417">
          Lo que <span className="text-[#00C853]" data-id="element-418">recibís</span>
        </h2>

        <div className="max-w-2xl mx-auto mb-12" data-id="element-419">
          <div className="bg-black border border-[#00C853]/30 rounded-2xl p-6" data-id="element-420">
            <h3 className="text-[#00C853] text-xl font-black mb-2" data-id="element-421">
              ⚽ 4 a 12 años — 6 TOMOS
            </h3>
            <p className="text-gray-400 text-sm mb-5" data-id="element-422">
              Para profes de Baby Fútbol y DTs de club de barrio
            </p>
            <div className="space-y-4" data-id="element-423">
              <div className="flex items-center gap-3 text-white" data-id="element-424">
                <span className="text-xl" data-id="element-425">🟢</span>
                <div className="flex-1" data-id="element-426">
                  <span className="font-bold" data-id="element-427">
                    Tomo 1 — JARDÍN DE FÚTBOL (4-5 años)
                  </span>
                  <span className="text-gray-300" data-id="element-428">
                    {' '}
                    Coordinación psicomotriz, dominio básico de pelota, giros,
                    frenos y el primer contacto con el juego. Sin filas, sin
                    esperas, solo juego y sonrisas.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-429">
                <span className="text-xl" data-id="element-430">🟡</span>
                <div className="flex-1" data-id="element-431">
                  <span className="font-bold" data-id="element-432">
                    Tomo 2 — LOS CIMIENTOS (6-7 años)
                  </span>
                  <span className="text-gray-300" data-id="element-433">
                    {' '}
                    Pase con cara interna, control orientado, remate con empeine
                    y primera introducción al 2 vs 1. Los gestos técnicos que si
                    se aprenden mal a los 7, duran mal para siempre.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-434">
                <span className="text-xl" data-id="element-435">🟠</span>
                <div className="flex-1" data-id="element-436">
                  <span className="font-bold" data-id="element-437">
                    Tomo 3 — EL ARTE DEL 1 VS 1 (8-9 años)
                  </span>
                  <span className="text-gray-300" data-id="element-438">
                    {' '}
                    Tijera doble, sombrero, amague de cuerpo, cambio de ritmo,
                    protección de pelota y quite limpio. El repertorio completo
                    del gambeteador argentino de barrio.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-439">
                <span className="text-xl" data-id="element-440">🔵</span>
                <div className="flex-1" data-id="element-441">
                  <span className="font-bold" data-id="element-442">
                    Tomo 4 — EL EQUIPO (10 años)
                  </span>
                  <span className="text-gray-300" data-id="element-443">
                    {' '}
                    Rombo y Cuadrado, transiciones coordinadas, pressing básico,
                    salida limpia desde el arquero y jugadas de pelota parada
                    ensayadas. El año donde el equipo nace como unidad.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-444">
                <span className="text-xl" data-id="element-445">🔴</span>
                <div className="flex-1" data-id="element-446">
                  <span className="font-bold" data-id="element-447">
                    Tomo 5 — TÁCTICA AVANZADA (11-12 años)
                  </span>
                  <span className="text-gray-300" data-id="element-448">
                    {' '}
                    Pressing total coordinado, contragolpe en 2 toques, cambios
                    de sistema en el partido y el nivel más alto posible dentro
                    del Baby Fútbol cancha de 5.
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-449">
                <span className="text-xl" data-id="element-450">⚫</span>
                <div className="flex-1" data-id="element-451">
                  <span className="font-bold" data-id="element-452">Tomo 6 — EL MALETÍN DEL DT</span>
                  <span className="text-gray-300" data-id="element-453">
                    {' '}
                    Planillas, fichas médicas, protocolos de emergencia,
                    comunicación con padres para todos los escenarios,
                    psicología deportiva básica y entrenamiento del arquero.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* What each tome includes */}
        <div className="bg-[#00C853]/5 border border-[#00C853]/30 rounded-2xl p-8 text-center" data-id="element-454">
          <h3 className="text-[#00C853] text-xl font-black mb-6" data-id="element-455">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-3xl mx-auto" data-id="element-456">
            <div className="flex items-start gap-2 text-left" data-id="element-457">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-458">✅</span>
              <span className="text-white text-sm" data-id="element-459">
                Planificación anual completa de 40 semanas lista para presentar
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-460">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-461">✅</span>
              <span className="text-white text-sm" data-id="element-462">
                80 Sesiones completamente redactadas con entrada en calor +
                ejercicios + fútbol libre
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-463">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-464">✅</span>
              <span className="text-white text-sm" data-id="element-465">
                Objetivos técnicos y tácticos con correcciones específicas por
                edad
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-466">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-467">✅</span>
              <span className="text-white text-sm" data-id="element-468">
                Variantes FÁCIL / MEDIO / PRO para cada ejercicio
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-469">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-470">✅</span>
              <span className="text-white text-sm" data-id="element-471">
                Variantes para grupos pequeños (8 chicos) y grupos grandes (30
                chicos)
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-472">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-473">✅</span>
              <span className="text-white text-sm" data-id="element-474">
                Plan B para días de lluvia o espacio reducido
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-475">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-476">✅</span>
              <span className="text-white text-sm" data-id="element-477">
                Tips del profe basados en 20 años de cancha argentina
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-478">
              <span className="text-[#00C853] font-bold flex-shrink-0" data-id="element-479">✅</span>
              <span className="text-white text-sm" data-id="element-480">
                Fichas de evaluación trimestral por nivel
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}